import React, { useRef } from "react";
import emailjs from "@emailjs/browser";
import "../styles/Contact.css"; // Keep your styles

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_xdhdw78", // replace with your EmailJS service ID
        "template_mi9rnol", // replace with your template ID
        form.current,
        "Ssg5b7tFGYJevy2y9" // replace with your public key
      )
      .then(
        (result) => {
          alert("✅ Message Sent Successfully!");
          form.current.reset();
        },
        (error) => {
          alert("❌ Failed to Send. Please try again.");
          console.error(error.text);
        }
      );
  };

  return (
    <section className="contact-section" id="contact">
      <div className="contact-wrapper">
        
        {/* Contact Info */}
        <div className="contact-card">
          <h2 className="contact-heading">Contact Us</h2>
          <p><strong>Company:</strong> Afrivision Consultants Ltd</p>
          <p><strong>Phone:</strong> +250 795 459 039</p>
          <p><strong>Email:</strong> info@afrivisionconsultants.com</p>
          <p><strong>Location:</strong> Kayonza,  Rwanda</p>

          {/* Google Map Embed */}
          <div className="contact-map">
            <iframe
              title="Google Map"
              src="https://www.google.com/maps?q=Kayonza,+Mukarange+Sector,+Rwanda&output=embed"
              // src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d997541.0022523142!2d29.9695!3d-1.9441!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x19dca42689b1a7c1%3A0x5f8d3eaa0787f8c1!2sKayonza%2C%20Rwanda!5e0!3m2!1sen!2srw!4v1731251111111!5m2!1sen!2srw"
              width="100%"
              height="250"
              style={{ border: 0, borderRadius: "10px" }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>

        {/* Contact Form */}
        <div className="contact-form-card">
          <h3 className="contact-form-heading">Send us a Message</h3>
          <form ref={form} onSubmit={sendEmail} className="contact-form">
            <input type="text" name="user_name" placeholder="Your Name" required />
            <input type="email" name="user_email" placeholder="Your Email" required />
            <textarea name="message" rows="5" placeholder="Your Message" required></textarea>
            <button type="submit" className="contact-btn">Send Message</button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
